import { useQuery } from '@tanstack/react-query'

import { fetchAttributes } from 'api/AccountAPI'
import {
  AttributeOption,
  attributeOptionToFilter,
  FilterConfigAndAvailableValues
} from 'utils/filters'

export const useAttributeFilters = (): FilterConfigAndAvailableValues[] | null => {
  const { data } = useQuery<AttributeOption[]>({
    queryKey: ['fetchAttributes'],
    queryFn: () => fetchAttributes()
  })

  if (!data) {
    return []
  }

  const attributeFilters: FilterConfigAndAvailableValues[] = []
  const labels = new Set()

  for (const option of data) {
    if (!labels.has(option.label)) {
      attributeFilters.push(attributeOptionToFilter(option))
    }

    labels.add(option.label)
  }

  return attributeFilters
}
